import "core-js/stable";
import IcecastMetadataPlayer from "../../libs/icecast-metadata-player";
import { setCurrentTrack, setLoading, setPlay } from "../Slice/radioInfoSlice";
import { radioInfoTypeSelector } from "../selectors/radioInfoSelector";
import { getStringWithPadStart } from "../../utils/utils";
import {
  startGTagEventsByPlayingTime,
  stopGTagEventsByPlayingTime,
} from "../../utils/googleTagManager";
import { logPlayingStreamError } from "../../api/adminService";
import {
  getValidVolumeValue,
  getVolumeValue,
  setVolumeValue,
} from "../../utils/playerVolume";
import throttle from "lodash.throttle";
import {
  fetchTrackDataApi,
  setAudioType,
  setCurrentContent,
  setCurrentEntity,
  setCurrentStreamType,
  setPlaying,
  setVolume,
} from "../Slice/playerSlice";
import { playerInfoSelector } from "../selectors/playerSelector";

const throttledSettingVolumeToLocalStorage = throttle(setVolumeValue, 1000);

export const createSocketTypeMiddleware = (type) => {
  /**
   * @param storeAPI {import('redux').MiddlewareAPI}
   */
  return (storeAPI) => {
    let isInit = false,
      /** @type {IcecastMetadataPlayer} */
      player;

    const initIcecast = async () => {
      const audioElement = new Audio();
      audioElement.volume = getVolumeValue();

      player = new IcecastMetadataPlayer(
        `${process.env.REACT_APP_STREAM}${type}`,
        {
          audioElement,
          onPlay: () => {
            storeAPI.dispatch(setPlay({ type, play: true }));
            storeAPI.dispatch(setLoading({ type, loading: false }));
            startGTagEventsByPlayingTime(type);
          },
          onStop: () => {
            storeAPI.dispatch(setPlay({ type, play: false }));
            storeAPI.dispatch(setLoading({ type, loading: false }));
            stopGTagEventsByPlayingTime();
          },
          onError: (message, err) => {
            // eslint-disable-next-line no-console
            console.log("error iceCast = ", message);
            // eslint-disable-next-line no-console
            console.log("error iceCast = ", err);
            storeAPI.dispatch(setPlay({ type, play: false }));
            storeAPI.dispatch(setLoading({ type, loading: false }));
            stopGTagEventsByPlayingTime();
            const radioInfo = radioInfoTypeSelector(storeAPI.getState(), type);
            logPlayingStreamError(message, {
              radioType: type,
              trackName: radioInfo.aboutTrack.title,
            });
          },
          onMetadata: (metadata) => {
            const date = new Date();

            // eslint-disable-next-line no-console
            console.log(
              `StreamTitle = %c${metadata.StreamTitle}`,
              "color: blue; font-style: italic",
              `${getStringWithPadStart(
                date.getHours(),
              )}:${getStringWithPadStart(
                date.getMinutes(),
              )}:${getStringWithPadStart(date.getSeconds())}`,
            );
            if (metadata.StreamTitle) {
              const data = { type, message: metadata.StreamTitle };
              storeAPI.dispatch(setCurrentTrack(data));
              storeAPI.dispatch(fetchTrackDataApi(data));
            }
          },
        },
      );

      if (process.env.NODE_ENV === "development") {
        window.icecast = player;
      }
    };

    return (next) => async (action) => {
      switch (action.type) {
        case "player/pause": {
          if (player) {
            player.stop();
          }

          return next(action);
        }
        case "player/playMedia": {
          if (player) {
            player.stop();
          }

          return next(action);
        }
        case `${type}/playStream`: {
          const radioInfo = radioInfoTypeSelector(storeAPI.getState(), type);
          storeAPI.dispatch(setPlaying(true));
          storeAPI.dispatch(setAudioType("stream"));
          storeAPI.dispatch(setCurrentStreamType(type));
          storeAPI.dispatch(setCurrentContent(radioInfo.aboutTrack));
          const isTrack = type === "mc" || type === "rock" || type === "lite";
          storeAPI.dispatch(setCurrentEntity(isTrack ? "track" : "release"));

          if (player) {
            player.stop();
          }

          if (!isInit) {
            await initIcecast();
          }

          storeAPI.dispatch(setLoading({ type, loading: true }));
          player.play();

          return next(action);
        }
        case "player/togglePlayer": {
          const { isPlaying, audioType, currentStreamType } =
            playerInfoSelector(storeAPI.getState());
          if (isPlaying && player) {
            player.stop();
          } else {
            if (
              !isInit &&
              audioType === "stream" &&
              currentStreamType === type
            ) {
              await initIcecast();
              storeAPI.dispatch(setLoading({ type, loading: true }));
              player.play();
            }
          }

          return next(action);
        }

        case `${type}/toggle`: {
          const { isPlaying } = radioInfoTypeSelector(
            storeAPI.getState(),
            type,
          );
          if (isPlaying) {
            player.stop();
          } else {
            if (!isInit) {
              await initIcecast();
            }
            player.play();
            storeAPI.dispatch(setLoading({ type, loading: true }));
          }
          return next(action);
        }
        case "set_volume_value": {
          const volumeValue = getValidVolumeValue(action.payload);
          storeAPI.dispatch(setVolume(volumeValue));

          if (player) {
            player.audioElement.volume = volumeValue;
          }

          throttledSettingVolumeToLocalStorage(volumeValue);

          return next(action);
        }
        default:
          return next(action);
      }
    };
  };
};
